<template>
  <div>
    <v-layout pa-4 align-center>
      <v-flex xs12 md6 class="text-left">
        <h3>Pembuatan Obat</h3>
      </v-flex>
      <v-flex xs3>
        <Datepicker
          :show="datePicker"
          :date="date"
          :isClearable="true"
          @date-change="handleDateChange"
        />
      </v-flex>
      <v-flex xs2 md1>
        <router-link :to="routeBack" active>
          <font-awesome-icon
            style="color: grey; margin-right: 10px"
            icon="home"
          />
        </router-link>
        <v-btn @click="refresh()" icon>
          <font-awesome-icon icon="sync-alt" :class="{ refresh: isRefresh }" />
        </v-btn>
      </v-flex>
      <v-flex xs4 md4>
        <v-text-field
          class="input"
          background-color="grey lighten-3"
          placeholder="Cari Pasien"
          solo
          dense
          hide-details
          flat
          prepend-inner-icon="mdi-magnify"
          single-line
          v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="data"
      item-key="id"
      :items-per-page="itemsPerRow"
      single-expand
      hide-default-footer
      @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      class="px-2"
      :page.sync="page"
      :height="height"
      :loading="isLoading"
    >
      <template v-slot:[`item.no`]="{ item }">
        <tr class="text-left">
          <td>
            {{ (page - 1) * itemsPerRow + data.indexOf(item) + 1 }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.isDraft`]="{ item }">
        <tr class="text-left">
          <td>
            <v-chip v-if="item.isDraft" class="draft-chip">Draft</v-chip>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length" class="expand px-0">
          <v-card flat>
            <v-row no-gutters class="pb-2">
              <v-col cols="1"></v-col>
              <v-col
                cols="5"
                class="text-left pl-5 grey--text caption container-expand"
                style="max-width: 400px"
              >
                <span>
                  {{ item.gender }} <br />
                  {{ item.ageFormatted }}
                </span>
                <span>
                  Diterima pada {{ item.timeStamps.date }} pukul
                  {{ item.timeStamps.time }} WIB
                </span>
              </v-col>
            </v-row>
          </v-card>

          <v-card flat color="grey lighten-4" class="text-right">
            <v-container class="py-0 px-1">
              <v-row no-gutters>
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="mx-2 hover"
                        v-bind="attrs"
                        v-on="on"
                        @click="onClick(item, 1)"
                      >
                        <v-icon>mdi-account</v-icon>
                      </v-btn>
                    </template>
                    <span>Data Sosial</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        icon
                        class="mx-2 hover"
                        v-on="{ ...tooltip }"
                        @click="onClick(item, 2)"
                      >
                        <v-icon>mdi-file-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Dokumen</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </td>
      </template>
    </v-data-table>
    <v-footer color="white">
      <v-container>
        <v-row>
          <v-pagination
            v-model="page"
            :length="lengthPage"
            total-visible="7"
            @input="getAllPatient()"
          ></v-pagination>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </v-footer>

    <v-dialog persistent :max-width="1200" v-model="dialog1">
      <SocialData
        v-if="selectedDialog === 1 && dialog1"
        :medical-record="selectedPatient.rm_number"
        @close-form="dialog1 = false"
        updatedFrom="drug-manufacturing"
      ></SocialData>
    </v-dialog>
    <v-dialog fullscreen persistent v-model="dialog2">
      <DrugManuEdit
        v-if="selectedDialog === 2 && dialog2"
        :patient="selectedPatient"
        @close-form="
          dialog2 = false;
          getAllPatient();
        "
        @show-snackbar="showSnackbar"
      />
    </v-dialog>
    <Snackbar
      :show="snackbar.show"
      :color="snackbar.color"
      :text="snackbar.text"
      :close="
        () => {
          snackbar.show = false;
        }
      "
    />
  </div>
</template>

<script>
import DrugManuEdit from './DrugManufacturing/DrugManuEdit';
import SocialData from '../../SharedComponent/SocialData.vue';
import jwtMixin from '@/mixin/jwtMixin';
import FormatMixin from '@/mixin/formatMixin';
import { getPharmacyPatientByCategory } from '@/fetchApi/Pharmacy';
import Datepicker from '@/components/SharedComponent/Datepicker/Datepicker.vue';
import { Snackbar } from '@/components/SharedComponent';

const _ = require('lodash');
const moment = require('moment-timezone');

export default {
  name: 'DrugManufacturing',
  mixins: [jwtMixin, FormatMixin],
  components: {
    DrugManuEdit,
    SocialData,
    Datepicker,
    Snackbar,
  },
  data() {
    return {
      tab: null,
      isRefresh: false,
      isExpanded: false,
      snackbar: '',
      date: moment().format('YYYY-MM-DD'),
      datePicker: false,
      isLoading: false,
      headers: [
        { text: 'No', align: 'start', value: 'no' },
        { text: 'Nama', value: 'name', width: '20%' },
        { text: 'No. RM.', value: 'rm_number' },
        { text: 'Tipe Penjaminan', value: 'assurance' },
        { text: 'Unit', value: 'unit' },
        { text: 'Nama Dokter', value: 'doctor' },
        { text: '', value: 'isDraft' },
      ],
      data: [],
      dialog1: false,
      dialog2: false,
      search: '',
      page: 1,
      rowsPerPage: 5,
      lengthPage: 0,
      selectedPatient: null,
      selectedDialog: null,
    };
  },
  watch: {
    search() {
      this.searchData(this);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.refreshAndAutoUpdate();
    });
  },
  computed: {
    route() {
      return this.$route.path;
    },
    routeSplit() {
      return this.$route.path.split('/');
    },
    routeController() {
      return this.routeSplit[2];
    },
    routeBack() {
      return `/farmasi/${this.routeController}`;
    },
    routeName() {
      switch (this.routeController) {
        case 'rawat-inap':
          return 'rawat inap';

        case 'rawat-jalan':
          return 'rawat jalan';

        case 'igd':
          return 'IGD';

        default:
          return '';
      }
    },
    itemsPerRow() {
      let itemRow = '';
      switch (this.$vuetify.breakpoint.name) {
        case 'xs' || 'sm' || 'md':
          itemRow = 5;
          break;
        case 'lg':
          itemRow = 7;
          break;
        case 'xl':
          itemRow = 12;
          break;
        default:
          return 5;
      }
      return itemRow;
    },
    height() {
      let height = 0;
      switch (this.$vuetify.breakpoint.name) {
        case 'md':
          height = '61vh';
          break;
        case 'lg':
          height = '63vh';
          break;
        case 'xl':
          height = '70vh';
          break;
      }
      return height;
    },
  },
  methods: {
    searchData: _.debounce(v => {
      // eslint-disable-next-line no-param-reassign
      v.page = 1;
      v.getAllPatient();
    }, 650),
    handleDateChange(updatedDate) {
      this.date = updatedDate;
      this.servicePage = 1;
      this.getAllPatient();
    },
    refresh() {
      this.isRefresh = true;
      this.search = '';
      this.page = 1;
      this.getAllPatient();
    },
    async getAllPatient() {
      try {
        this.isLoading = true;
        const params = {
          date: this.date || '',
          category: 'production',
          type: this.routeName.toLowerCase(),
          page: this.page,
          itemCount: this.itemsPerRow,
          search: this.search || '',
        };
        const response = await getPharmacyPatientByCategory(params);
        const patient = response.data.data;
        const dataLength = response.data.length;
        this.lengthPage = Math.ceil(dataLength / this.itemsPerRow);
        this.data = patient.map(data => {
          return {
            id: data._id.toString(),
            id_emr: data.id_recipe.id_emr,
            id_registration: data.id_recipe.id_registration,
            id_recipe: data.id_recipe._id.toString(),
            name: data.name,
            rm_number: data.medical_record_number,
            assurance: data.assurance.toUpperCase(),
            isDraft: data.isDraft,
            unit: data.unit,
            gender: data.gender ? 'Laki-laki' : 'Perempuan',
            age: data.age,
            ageFormatted: this.ageDuration(moment(data?.birth_date)),
            doctor: data.doctor,
            officer: data.staff_order,
            timeStamps: {
              date: data.timestamps?.production_at
                ? moment(data.timestamps?.production_at).format('DD-MM-YYYY')
                : '-',
              time: data.timestamps?.production_at
                ? moment(data.timestamps?.production_at).format('HH:mm')
                : '-',
            },
          };
        });
      } catch (error) {
        this.data = [];
        this.lengthPage = 1;
      } finally {
        this.isRefresh = false;
        this.isLoading = false;
      }
    },
    refreshAndAutoUpdate() {
      if (this.interval !== null) {
        this.interval = clearInterval(this.interval);
      }
      this.getAllPatient();
      this.interval = setInterval(this.getAllPatient, 60000);
    },
    onClick(item, val) {
      this.selectedDialog = val;
      this.selectedPatient = item;
      val === 1 ? (this.dialog1 = true) : (this.dialog2 = true);
    },
    showSnackbar(snackbar) {
      this.snackbar = snackbar;
    },
  },
  beforeDestroy() {
    this.interval = clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid #e7e7e7;
}
.refresh {
  animation: rotation 0.23s infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.container-expand {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
}
.icon {
  float: right;
  padding-left: 20px;
}

::v-deep {
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > td:not(.v-data-table__mobile-row),
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > th:not(.v-data-table__mobile-row) {
    border: none;
  }
}
.pagination {
  position: absolute;
  bottom: 3vh;
}

.draft-chip {
  color: #eb4646;
  border: 1px solid #eb4646;
  font-weight: 500;
  border-radius: 5px;
  background-color: #fff2f2 !important;
}
</style>
